import { CONFIGURABLE_PAGE_IDS } from '@bupa-kkv/features/company-creation/types';
import { useQuery } from '@tanstack/react-query';
import { fetchPricingPageConfiguration } from '../../api/pricing-page.api';

export const useSelfEmployedConfigurationData = () => {
  return useQuery({
    queryKey: ['selfEmployedConfigurationData'],
    queryFn: () =>
      fetchPricingPageConfiguration(
        CONFIGURABLE_PAGE_IDS.SELF_EMPLOYMENT_PRICING_PAGE
      ),
  });
};
